export const LinkedinIcon = () => (
  <svg fill="currentColor" height="16" viewBox="0 0 16 16" width="16">
    <path d="M13.333 1.333H2.667c-.734 0-1.334.6-1.334 1.334v10.666c0 .734.6 1.334 1.334 1.334h10.666c.734 0 1.334-.6 1.334-1.334V2.667c0-.734-.6-1.334-1.334-1.334ZM5.333 12.667H3.333V6.333h2v6.334Zm-1-7.2a1.167 1.167 0 1 1 0-2.334 1.167 1.167 0 0 1 0 2.334Zm8.334 7.2h-2V9.6c0-.733-.014-1.68-1.02-1.68-1.02 0-1.18.8-1.18 1.627v3.12h-2V6.333h1.92v.867h.027c.267-.507.92-1.04 1.893-1.04 2.027 0 2.4 1.333 2.4 3.067v3.44h-.04Z" />
  </svg>
);

export const FacebookIcon = () => (
  <svg fill="currentColor" height="16" viewBox="0 0 16 16" width="16">
    <path d="M14.667 8a6.667 6.667 0 1 0-7.709 6.586v-4.66H5.333V8h1.625V6.5c0-1.607.957-2.492 2.42-2.492.7 0 1.434.125 1.434.125v1.578h-.808c-.795 0-1.044.494-1.044 1v1.289h1.778l-.284 1.926H8.96v4.66A6.668 6.668 0 0 0 14.667 8Z" />
  </svg>
);

export const XTwitterIcon = () => (
  <svg fill="currentColor" height="16" viewBox="0 0 16 16" width="16">
    <path d="M12.258 2h2.083L9.617 7.24 15 14h-4.33l-3.41-4.459L3.453 14H1.37l5.06-5.78L1 2h4.44l3.083 4.074L12.258 2Zm-.73 10.783h1.154L4.53 3.182H3.287l8.24 9.601Z" />
  </svg>
);

export const YoutubeIcon = () => (
  <svg fill="currentColor" height="16" viewBox="0 0 16 16" width="16">
    <path d="M14.36 4.767a1.794 1.794 0 0 0-1.263-1.27C12.04 3.2 8 3.2 8 3.2s-4.04 0-5.097.297a1.794 1.794 0 0 0-1.263 1.27C1.333 5.83 1.333 8.04 1.333 8.04s0 2.21.307 3.273c.169.633.666 1.11 1.263 1.27C3.96 12.88 8 12.88 8 12.88s4.04 0 5.097-.297a1.776 1.776 0 0 0 1.263-1.27c.307-1.063.307-3.273.307-3.273s0-2.21-.307-3.273ZM6.6 10.12V5.96l3.4 2.08-3.4 2.08Z" />
  </svg>
);

export const ColleagueIcon = () => (
  <svg fill="currentColor" height="16" viewBox="0 0 16 16" width="16">
    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 1.333c-2.003 0-6 1.007-6 3V14h12v-1.667c0-1.993-3.997-3-6-3Z" />
  </svg>
);
